import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Text } from './Text';

function ManySignature({ effacer, onSignatureChange, className }) {
  const signatureRef = useRef();
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [signatureDataUrl, setSignatureDataUrl] = useState(null);
  const [isSignatureEmpty, setIsSignatureEmpty] = useState(true);

  const clearSignature = () => {
    signatureRef.current.clear();
    setIsSignatureEmpty(true);
    onSignatureChange(null);
    setIsConfirmed(false);
  };

  const saveSignature = () => {
    const signatureDataUrl = signatureRef.current.toDataURL();
    const link = document.createElement('a');
    link.href = signatureDataUrl;
    link.download = 'signature.png';
    link.click();
  };

  const confirmSignature = () => {
    if (!isSignatureEmpty) {
      setIsConfirmed(true);
      setSignatureDataUrl(signatureRef.current.toDataURL());
      const signatureData = signatureRef.current.toDataURL();
      onSignatureChange(signatureData);
    }
  };

  // console.log(className, "className");

  return (
    <div className={className || "flex flex-col items-center gap-2 w-full max-w-[300px]"}>
      <div className="signature-canvas-border rounded-md">
      <SignatureCanvas
          ref={signatureRef}
          penColor="black"
          canvasProps={{
            width: '200%',
            height: '100%',
            className: 'signature-canvas',
          }}
          onBegin={() => setIsSignatureEmpty(false)}
        />
      </div>

      {isConfirmed && (
        <Text
          className="text-black text-xs font-medium"
          size="txtInterRegular"
        >
          Signature confirmée
        </Text>
      )}

      <div className="flex gap-2 w-full justify-center">
        <button 
          className="px-4 py-1.5 signature-button-delete text-xs font-medium transition-colors"
          onClick={clearSignature}
        >
          Effacer
        </button>
        <button
          className={`px-4 py-1.5 signature-button-confirm rounded text-xs font-medium transition-colors
           `}
          onClick={confirmSignature}
          disabled={isSignatureEmpty}
        >
          Confirmer
        </button>
      </div>
    </div>
  );
}

export default ManySignature;
